export const duetHeadingLevels = ["h1", "h2", "h3", "h4", "h5", "h6"] as const
export const duetBlock = "div" as const
